import React, {useState} from 'react';
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {useFieldArray, useForm} from "react-hook-form";
import _ from "lodash"
import RustarFormParsItem from "../components/rustarFormParsItem";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import {Tab, Table, Tabs} from "react-bootstrap";
import sayError from "../../../helpers/sayError";
import RustarRows from "../components/addCashRows";
import KayarKassaRows from "../components/kayarKassaRows";
import BlockUi from "@availity/block-ui";


const tempValues ={
  texts: [{countryType:"UAE", text: ''}]
}
const RustarPayments = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [tabIndex, setTabIndex] = useState("incorrect");
  const [countryTypes, setCountryTypes] = useState(["UAE","MDV","GEO","TUR"].map(v=>({label:v, value:v})))
  const formController = useForm({defaultValues:tempValues})
  const {control,
    getValues,
    reset,
    handleSubmit} = formController

  const textsControl = useFieldArray({
    control,
    name: `texts`,
    rules: {required: true},
    keyName: 'customId',
  });

  const onSubmit = (value) =>{
    setLoading(true)
    let sendInfo = {}
    value.texts.forEach(v=>{
      if(v.text.length>0){
        sendInfo[v.countryType] = v.text
      }
    })
    if(Object.keys(sendInfo).length>0){
      axios.post('/api/racoon/rustar/parse',sendInfo)
        .then(({data})=>{
          console.log(data)
          setData(data)
          if(data.missedRegions.length>0){
            data.missedRegions.forEach(reg=>{
              if(!_.find(getValues().texts, {countryType:reg})){
                if(!_.find(countryTypes, {value: reg})){
                  setCountryTypes(old=>[...old,{label:reg, value:reg}])
                }
                textsControl.append({countryType: reg, text: ''})
              }
            })
          }
        })
        .catch(sayError)
    }else{
      window.alert('Вы не вставили ни одного текста для парса')
    }
    setLoading(false)
  }
  return (
    <>
      <Helmet>
        <title>Оплаты Rustar</title>
      </Helmet>
      <BlockUi blocking={loading}>
        <Portlet>
          <form onSubmit={handleSubmit(onSubmit)}>
            <PortletHeader title={'Оплаты Rustar'} toolbar={<PortletHeaderToolbar>
              <LoadingButton title={'Сравнить'} loading={loading}/>
            </PortletHeaderToolbar>}/>
            <PortletBody className={'pt-2'}>
              <div className={'mt-4 d-flex gap-2 align-items-center'}>
                {textsControl.fields.map((row, index) => {
                  return <React.Fragment key={index}>
                    <RustarFormParsItem formController={formController}
                                        countryTypes={countryTypes}
                                        prefix={`texts[${index}]`}
                                        strData={row}/>
                  </React.Fragment>
                })}
                <i className={'fa fa-plus pointer mb-2 h5'} onClick={()=>{
                  textsControl.append({countryType:'', text: ''})
                }}/>
                <i className="fa fa-window-close text-danger mb-2 h5 pointer"
                   onClick={()=>{
                     reset()
                     setData()
                   }}/>
              </div>
              {data && data?.missedRegions.length ? <div className={'text-danger'}>Для получения полной информации добавьте инфо из {data.missedRegions.join(', ')}</div>:''}

            </PortletBody>
          </form>
        </Portlet>
        {data && <Tabs
          id="controlled-tab-example"
          activeKey={tabIndex}
          onSelect={key => {
            setTabIndex(key)
          }}
        >
          <Tab title={'Требует проверки'} eventKey={'incorrect'}>
            <Portlet>
                <Table bordered>
                  <thead>
                  <tr align={'center'} className={'bg-secondary'}>
                      <th colSpan={5} >У Рустара нет поступления, есть у нас</th>
                  </tr>
                    <tr>
                      <th>Строка</th>
                      <th>Таблица</th>
                      <th>Дата</th>
                      <th>Контрагент</th>
                      <th>Сумма</th>
                    </tr>
                  </thead>
                  <tbody>
                  {data.cashPayments.missedPayments.map((row, index) => {
                    return <tr key={index}>
                      <td>{row.index}</td>
                      <td>{row.table}</td>
                      <td>{row.date}</td>
                      <td>{row.counterparty || "Наша оплата в Рустар"}</td>
                      <td>{row.paid.amount} {row.paid.currency}</td>
                    </tr>
                  })}
                  </tbody>
                </Table>
                {data.cashPayments.similarPayments.length>0 &&
                  <Table bordered>
                    <thead>
                    <tr align={'center'} className={'bg-secondary'}>
                      <th colSpan={5}>У нас непонятные поступления, но есть похожее</th>
                    </tr>
                    <tr>
                      <th>Строка</th>
                      <th>Таблица</th>
                      <th>Дата</th>
                      <th>Контрагент</th>
                      <th>Сумма</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.cashPayments.similarPayments.map((row, index) => {
                      return <tr key={index}>
                        <td>{row.index}</td>
                        <td>{row.table}</td>
                        <td>{row.date}</td>
                        <td>{row.counterparty || "В Рустар"}</td>
                        <td>{row.paidAmount} {row.paidCurrency}</td>
                      </tr>
                    })}
                    </tbody>
                  </Table>}
                <Table bordered>
                  <thead>
                  <tr align={'center'} className={'bg-secondary'}>
                    <th colSpan={5}>У нас нет поступлений по кассе</th>
                  </tr>
                  <tr>
                    <th>Дата</th>
                    <th>Регион</th>
                    <th>Сумма</th>
                    <th>Тип</th>
                    <th>Комментарий</th>
                  </tr>
                  </thead>
                  <tbody>
                  {data.rustarPayments.missedPayments.map((row,index)=>{
                    return <tr key={index}>
                      <td>{row.date}</td>
                      <td>{row.region}</td>
                      <td style={{textWrap: 'nowrap'}}>{row.paidAmount} {row.paidCurrency}</td>
                      <td>{row.type}</td>
                      <td>{row.discription}</td>
                    </tr>
                  })}
                  </tbody>
                </Table>
            </Portlet>
          </Tab>
          <Tab title={'Правильные'} eventKey={'correct'}>
            <Portlet>
              <Table bordered>
                <thead>
                <tr>
                  <th>Дата</th>
                  <th>Регион</th>
                  <th>Сумма</th>
                  <th>Тип</th>
                </tr>
                </thead>
                <tbody>
                {data.rustarPayments.correctPayments.map((row,index)=>{
                  return <tr key={index}>
                    <td>{row.date}</td>
                    <td>{row.region}</td>
                    <td>{row.paidAmount} {row.paidCurrency}</td>
                    <td>{row.type}</td>
                  </tr>
                })}
                </tbody>
              </Table>
            </Portlet>
          </Tab>
        </Tabs>
        }
      </BlockUi>
</>
)
  ;
};

export default RustarPayments;
